export default __webpack_public_path__ + "static/media/huaxia.4a510c42.png";